import React, { ReactNode, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "./";
import LabelText from "../LabelText";
import ChipComponent from "../Chip";
import { IPlayerCardDetail } from "../../types/IPlayerCardDetail";
import { useNavigate } from "react-router-dom";
import More from "../../assets/icons/More.png";
import LabelNumber from "../../styled-components/LabelNumber";
import noImageplayer from "../../assets/icons/noImagePlayer.svg";
import Spyglass from "../../assets/icons/Spyglass.png";
import PlayerIcon from "../../assets/icons/Profile.png";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Bookmark from "../../assets/icons/Bookmark.png";
import { useAuth } from "../../contexts/AuthContext";
import { useLoading } from "../../contexts/LoadingContext";
import { useNotification } from "../../contexts/NotificationContext";
import { addUpdateSortListData } from "../../components/PlayerComparison/addOrUpdateSortList";
import RemoveIcon from "../../assets/icons/remove.png";
import Tick from "../../assets/icons/Tick.png";
import VisibleOFF from "../../assets/icons/VisibleOFF.png";
import { ModuleSpinner } from "../LoadingSpinner/ModuleSpinner";
import { InfoOutlined } from "@mui/icons-material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import PWNotification from "../../components/PWNotification";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import { useNewPlayerShortlistContext } from "../../contexts/NewPlayerShortlistContext";
import GoldStar from "../../assets/icons/GoldStar.png";
import { ArchetypeInfoDrawer } from "../../pages/Chemistry/UIContent";
import InfoIcon from "../../assets/icons/infoicon.svg";

const PlayerCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 14px 16px;
  border-radius: 8px;
  // width: calc(25% - 24px);
  // margin: 0px 12px 15px;
  border: 1px solid #dadada;
  background: ${({ theme }) => theme.playerContentBackground};
  @media (max-width: 1700px) {
    width: calc(33.3% - 65px);
  }
  @media (max-width: 1365px) {
    width: calc(50% - 65px);
  }
  @media (max-width: 1200px) {
    width: calc(50% - 65px);
  }
  @media (max-width: 991px) {
    width: calc(100% - 65px);
  }
`;

const PlayerHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  padding: 0px 34px;
  justify-content: center;
  margin-bottom: 8px;
  position: relative;

  .playerNumber {
    // position: absolute;
    // right: 0px;
    color: ${({ theme }) => theme.NumberColor};
    text-align: right;
    font-feature-settings: "clig" off, "liga" off;
    /* DM-Mono/Title/Large */
    font-family: "DM Mono";
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 100% */
    text-transform: uppercase;
  }

  .selected-player-in-card {
    position: absolute;
    left: 0px;
  }
`;

const PlayerAvatar = styled.div<{ backgroundImage: string }>`
  width: 155px;
  height: 155px;
  flex-shrink: 0;
  border-radius: 328.125px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.borderColor};
  background: url(${(props) => props.backgroundImage}) lightgray 50% / cover no-repeat;
`;

const PlayerNameHeader = styled.div`
  display: contents;
  cursor: pointer;
  .squad-number {
    justify-content: space-between;
    display: flex;
    align-items: center;
    align-self: stretch;
  }
  .position-text {
    cursor: default;
    display: flex;
    justify-content: flex-start;
    // min-height: 40px;
  }
  & .drawer-title {
    height: 100%;
    font-family: "Aeonik";
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    @media (max-width: 1366px) {
      font-size: 24px;
    }
  }
`;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  justify-content: space-between;
`;

const PlayerCardFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;

const getBackgroundColor = (value?: number): string => {
  if (value == null) {
    return "none";
  }
  value = Math.ceil(value);
  if (value > 0 && value <= 24.99) {
    return "var(--UI-red-500, #FF3864)";
  } else if (value >= 25 && value <= 49.99) {
    return "var(--Brand-orange-500, #FF7800)";
  } else if (value >= 50 && value <= 74.99) {
    return "var(--UI-yellow-500, #F2E94E)";
  } else if (value >= 75 && value <= 87.99) {
    return "#C9F0B6";
  } else if (value >= 88 && value <= 98.99) {
    return "var(--Brand-green-2-500, #4AF075)";
  } else if (value >= 99) {
    return "#00D1A8";
  } else if (value === 0) {
    return "#DADADA";
  } else {
    return "red";
  }
};

const PlayerLandingCard: React.FC<IPlayerCardDetail> = ({
  playerId,
  givenName,
  familyname,
  playerImageURL,
  isInjured,
  onLoan,
  givenOnLoan,
  primaryPlayingPosition,
  age,
  heightInCM,
  playerAttributesByPosition,
  contributionValue,
  performanceValue,
  clubImageURL,
  setPlayerCardID,
  setPlayerCardDeatils,
  isRemoveAvailable = true,
  isFormSortList = false,
  handleRemoveSinglePlayer,
  isSelectorRequired = false,
  isPlayerSelected = false,
  isPlayerHidden = false,
  handleSelectedPlayer,
  isPlayerInShortlist,
  archetypeName,
  archetypeId,
  trueValueText,
}) => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const { loading, startLoading, stopLoading } = useLoading();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isShowNotification, setIsShowNotification] = useState(false);
  const {
    showNotification,
    hideNotification,
    displayNotification,
    setDisplayNotification,
    notificationContent,
    setNotificationContent,
    setShouldHideAfterTimeout,
    displayCardNotification,
    seIsDisplayCardNotification,
    cardNotificationContent,
    setCardNotificationContent,
  } = useNotification();
  const [addedPlayerShortList, setAddedPlayerShortList] = useState<boolean>(false);
  const [toggleAddCardButton, setIsToggleAddCardButton] = useState<boolean>();
  const goToDetailPage = () => {
    navigate(`/player/${playerId}`);
  };
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipTimeout = useRef<NodeJS.Timeout | null>(null);
  const handleMouseEnter = () => {
    tooltipTimeout.current = setTimeout(() => {
      setShowTooltip(true);
    }, 500);
  };
  const handleMouseLeave = () => {
    if (tooltipTimeout.current) {
      clearTimeout(tooltipTimeout.current);
    }
    setShowTooltip(false);
  };
  const [infoHovered, setInfoHovered] = useState<boolean>(false);
  const hoverTimeout = useRef<NodeJS.Timeout | null>(null);
  const handleMouseEnterContribution = () => {
    hoverTimeout.current = setTimeout(() => {
      setInfoHovered(true);
    }, 500);
  };
  const handleMouseLeaveContribution = () => {
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
    }
    setInfoHovered(false);
  };

  useEffect(() => {
    setIsToggleAddCardButton(isPlayerInShortlist!);
  }, [isPlayerInShortlist]);

  const { newlyAddedPlayerCount, setNewlyAddedPlayerCount } = useNewPlayerShortlistContext();

  const handleActions = () => {
    setIsToggleAddCardButton(!toggleAddCardButton);
    addUpdateSortListData(
      userData,
      [playerId!],
      startLoading,
      stopLoading,
      seIsDisplayCardNotification,
      setCardNotificationContent,
      false,
      navigate
    );
  };

  const handleAddPlayer = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event?.preventDefault();
    event?.stopPropagation();
    setIsShowNotification(true);
    setDisplayNotification(true);
    setIsToggleAddCardButton(!toggleAddCardButton);
    if (toggleAddCardButton) {
      setAddedPlayerShortList(false);
      addUpdateSortListData(
        userData,
        [playerId!],
        startLoading,
        stopLoading,
        seIsDisplayCardNotification,
        setCardNotificationContent,
        true,
        navigate
      );
    } else {
      setNewlyAddedPlayerCount((prev) => prev + 1);
      setAddedPlayerShortList(true);
      addUpdateSortListData(
        userData,
        [playerId!],
        startLoading,
        stopLoading,
        seIsDisplayCardNotification,
        setCardNotificationContent,
        false,
        navigate
      );
    }
  };

  useEffect(() => {
    setCardNotificationContent(
      <div className="notification">
        {/* <InfoOutlinedIcon className='icon' /> */}
        <p className="sortlist-notofication-content">
          <BookmarkBorderOutlinedIcon className="icon" />
          <LabelText className="squad-chart-tooltip notification-content">
            {addedPlayerShortList ? "Player added to your shortlist " : "Player removed from your shortlist"}
          </LabelText>
          {addedPlayerShortList ? (
            <LabelText
              className="player-given-name notification-content"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/shortlists")}
            >
              View shortlist
            </LabelText>
          ) : (
            <LabelText className="player-given-name notification-content" style={{ cursor: "pointer" }} onClick={() => handleActions()}>
              Undo
            </LabelText>
          )}
        </p>
      </div>
    );
  }, [toggleAddCardButton, addedPlayerShortList]);

  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  return (
    <>
      <PlayerCard className="player-card" onClick={() => (setPlayerCardID ? setPlayerCardID(0) : () => {})}>
        {loading && <ModuleSpinner />}
        <PlayerHeader>
          {isPlayerSelected && (
            <div className="plot-player-image-selected selected-player-in-card" onClick={(event) => handleSelectedPlayer!(event, playerId)}>
              <img src={Tick} className="plot-tick-mark" alt="selected-mark" />
            </div>
          )}
          {isPlayerHidden && (
            <div className="plot-player-image-hidden selected-player-in-card" onClick={(event) => handleSelectedPlayer!(event, playerId)}>
              <img src={VisibleOFF} alt="hidden-player" />
            </div>
          )}
          {isSelectorRequired && (
            <div className="plot-player-image-in-card selected-player-in-card" onClick={(event) => handleSelectedPlayer!(event, playerId)}>
              {clubImageURL && !loading && <img src={clubImageURL} style={{ width: "30px", height: "30px" }} alt="club-image" />}
            </div>
          )}
          <div className="status-avatar-container">
            <div className="status-label">
              {onLoan && <ChipComponent status={"LOANED IN"} />}
              {givenOnLoan && <ChipComponent status={"LOANED OUT"} />}
              {isInjured && <ChipComponent status={"INJURED"} />}
            </div>
            <PlayerAvatar onClick={() => goToDetailPage()} backgroundImage={playerImageURL ? playerImageURL : noImageplayer} />
          </div>
          <div
            className={`${isMenuOpen && "more-squad-button-clicked "} more-squad-button`}
            onClick={(event) => {
              event.stopPropagation();
              setIsMenuOpen(!isMenuOpen);
            }}
          >
            <img src={More} alt="more-menu" />
          </div>
          {isMenuOpen && (
            <div className="squad-player-menu">
              <LabelNumber className="attack-defense-data">OPTIONS</LabelNumber>
              <div>
                {isFormSortList && handleRemoveSinglePlayer && (
                  <button
                    className="remove-from-shortlist-btn"
                    onClick={() => {
                      setIsShowNotification(true);
                      handleRemoveSinglePlayer!(playerId);
                    }}
                  >
                    <img src={RemoveIcon} alt="remove-from-shortlist" />
                    {isShowNotification ? "Removed" : "Remove"} from shortlist
                  </button>
                )}
                <button onClick={() => goToDetailPage()}>
                  <img src={PlayerIcon} alt="player-profile" />
                  <LabelText className="menu-list">Player Profile</LabelText>
                </button>
                <button onClick={() => navigate(`/player/${playerId}?tab=true`)}>
                  <img src={Spyglass} alt="similar-icon" />
                  <LabelText className="menu-list">Search for similar</LabelText>
                </button>

                {!isFormSortList && (
                  <div
                    className={`menu-list-container ${toggleAddCardButton ? "added" : ""}`}
                    onClick={(event) => {
                      handleAddPlayer(event);
                    }}
                  >
                    <BookmarkBorderIcon />
                    <LabelText className="menu-list" style={{ color: toggleAddCardButton ? "white" : "" }}>
                      {toggleAddCardButton ? "Added" : "Add"} to shortlist
                    </LabelText>
                  </div>
                )}

                {isRemoveAvailable && (
                  <button
                    onClick={(event) => {
                      event.stopPropagation();
                      setPlayerCardID!(0);
                      setPlayerCardDeatils!(undefined);
                    }}
                  >
                    <CloseIcon />
                    Close
                  </button>
                )}
              </div>
            </div>
          )}
        </PlayerHeader>
        <CardInfo>
          <PlayerNameHeader>
            <div className="squad-number">
              <LabelText className="player-given-name" onClick={() => goToDetailPage()}>
                {givenName}
              </LabelText>
            </div>
            <LabelText className="drawer-title" onClick={() => goToDetailPage()}>
              {familyname}
            </LabelText>
            <LabelNumber className="position-text">Position : {primaryPlayingPosition}</LabelNumber>
            {trueValueText && <LabelNumber className="position-text">True Value : {trueValueText}</LabelNumber> }
            {archetypeName && (
              <LabelNumber className="position-text">
                {archetypeName}
                <img src={InfoIcon} alt="archetpe-info" className="archetype-info-icon-sortlist" onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  document.querySelectorAll('.squad-pitch-player-card').forEach((card) => {
                    (card as HTMLElement).style.zIndex = '9999';
                  });
                  setSidebarOpen(true);
                }} />
              </LabelNumber>
            )}
          </PlayerNameHeader>
          <PlayerCardFooter>
            <div className="age-height-container">
              <p>
                AGE <span className="age-height-value">{age ? age : "--"}</span>
              </p>
              <span className="age-height-dot">.</span>
              <p>
                HEIGHT <span className="age-height-value">{heightInCM ? heightInCM : "--"}CM</span>
              </p>
            </div>
            {playerAttributesByPosition?.length === 0 && (
              <div className="gk-attribute-container">
                {primaryPlayingPosition === "Goalkeeper" ? (
                  <div>
                    <span>Goalkeeper attributes</span>
                    <span>not currently available</span>
                  </div>
                ) : (
                  <div>
                    <span>Player attributes</span>
                    <span>not currently available</span>
                  </div>
                )}
              </div>
            )}
            {playerAttributesByPosition?.length > 0 && (
              <div className="squad-atrribute-container">
                {playerAttributesByPosition?.map((attribute) => (
                  <div
                    className="squad-player-attributes"
                    style={{
                      backgroundColor: getBackgroundColor(attribute?.attributeValue),
                      borderColor: getBackgroundColor(attribute?.attributeValue),
                      color: attribute?.attributeValue <= 49.99 && attribute?.attributeValue >= 1 ? "#FFFFFF" : "#111111",
                    }}
                  >
                    <p>{attribute?.attributeName}</p>
                    <div className="attribute-value-container">
                      {attribute?.attributeValue === 0 && showTooltip && <div>Not enough data</div>}
                      {attribute?.attributeValue === 0 && <InfoOutlined onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />}
                      <p>
                        {attribute?.attributeValue >= 99 ? (
                          <span className="star-performer-container">
                            <img src={GoldStar} alt="star-performer" />
                          </span>
                        ) : null}{" "}
                        {attribute?.attributeValue >= 1 ? attribute?.attributeValue === 100 ? "99.99" : attribute?.attributeValue?.toFixed(2) : "--"}
                      </p>
                    </div>
                  </div>
                ))}
                <div className="squad-contribution-attributes">
                  <div className="contribution-icon">
                    <p>ATTACK CONTRIBUTION</p>
                    <InfoOutlinedIcon onMouseEnter={handleMouseEnterContribution} onMouseLeave={handleMouseLeaveContribution} />
                    {infoHovered && <div>Attack contribution by position</div>}
                  </div>
                  <p>{contributionValue ? contributionValue : performanceValue ? performanceValue : "--"}</p>
                </div>
              </div>
            )}
          </PlayerCardFooter>
        </CardInfo>
        {archetypeName && archetypeId && <ArchetypeInfoDrawer
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          archetypeName={archetypeName!}
          activeArchetypeID={archetypeId!}
          playerPosition={primaryPlayingPosition}
        />}
      </PlayerCard>
    </>
  );
};

export default PlayerLandingCard;
